import { isEqual } from 'lodash'
import { memo, useCallback, useContext, useEffect, useState } from 'react'
import Table from '../../components/Table'
import { metodoPrograma } from '../../components/api'
import {
  Autocomplete,
  IconButton,
  Grid,
  TextField as MaterialTextField,
} from '@mui/material'
import { IoReload } from 'react-icons/io5'
import { MdDelete } from 'react-icons/md'
import { GlobalContext } from '../../App'

const ListaUsuario = ({
  contratante,
  setUsuarioAberto,
  setTela,
  idTipoUsuario,
  setIdTipoUsuario,
}) => {
  const { localAtendimento } = useContext(GlobalContext)
  const [lista, setLista] = useState([])
  const [tiposUsuario, setTiposUsuario] = useState([])

  const buscaLista = useCallback(async () => {
    const dados = {
      idLocalAtendimento: localAtendimento[0],
      idContratante: contratante[0],
      idTipoUsuario,
      CnstPagnation: [1000, 1, '', []],
    }
    const res = await metodoPrograma('lista', dados)
    setLista(res.lista || [])
  }, [contratante, idTipoUsuario, localAtendimento])

  const buscaTipoUsuario = useCallback(async () => {
    metodoPrograma('listaTiposUsuario').then((res) =>
      setTiposUsuario(res.lista),
    )
  }, [])

  useEffect(() => {
    buscaTipoUsuario()
    buscaLista()
  }, [buscaLista, buscaTipoUsuario])

  const handleClick = (_, linha) => {
    setUsuarioAberto(linha)
    setTela('edicao')
  }

  const exclui = (idUsuario) => async (e) => {
    e.stopPropagation()
    if (
      !window.confirm(
        'Mas você tem CERTEZA que deseja excluir esta forma de pagamento?',
      )
    )
      return
    await metodoPrograma('exclui', { idUsuario })
    await buscaLista()
  }

  const handleChange = (event, newValue) => {
    setIdTipoUsuario(newValue.tipo)
    buscaLista()
  }

  return (
    <>
      <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
        <Autocomplete
          name="tpUsuario"
          component={Autocomplete}
          options={tiposUsuario}
          onChange={handleChange}
          getOptionLabel={(option) => (option.tipo ? option.desc : '')}
          getOptionSelected={(o, v) => o?.tipo === v?.tipo}
          noOptionsText="Não Encontrado"
          clearText="Limpar"
          openText="Abrir"
          renderInput={(params) => (
            <MaterialTextField
              margin="dense"
              variant="outlined"
              label="Tipo de Usuário"
              {...params}
            />
          )}
        />
      </Grid>
      <Table
        dados={lista}
        head={['ID', 'Tipo', 'E-mail', 'Nome', 'Inclusão', 'Exclusão', '']}
        line={(l) => [l[0], l[1][1], l[2], l[3], l[4], l[5]]}
        onClick={handleClick}
        columnOptions={[
          {
            alias: 7,
            customJsx: ({ linhaOriginal }) => (
              <IconButton size="small" onClick={exclui(linhaOriginal[0])}>
                {linhaOriginal[5] ? <IoReload /> : <MdDelete />}
              </IconButton>
            ),
          },
        ]}
      />
    </>
  )
}

export default memo(ListaUsuario, isEqual)
